import React from 'react'
import {
  Container,
  Grid,
  makeStyles,
  withWidth,
} from '@material-ui/core'
import Page from 'src/components/Page'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useLocation, useParams } from 'react-router-dom'
import ProfileImage from './ProfileImage'
import ProfileInfo from './ProfileInfo'
import { selectorUserProfile } from '../../../app/slices/userSlice'
import { getUser } from '../../../app/slices/usersSlice'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  removeHeader: {
    '& > div > div:nth-child(1)': {
      display: 'none',
    },
  },
}))

const ProfileView = ({ width }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const location = useLocation()
  const { userId } = useParams()
  const fileRef = React.useRef(null)
  const userProfile = useSelector(selectorUserProfile)
  const scholarship = useSelector((state) => state.scholarship.current)
  const users = useSelector((state) => state.users?.current?.profile)
  const [status, setStatus] = React.useState({})

  console.log(userProfile?.photo?.url)

  const statusType = {
    EDIT_PROFILE: {
      name: 'edit_profile',
      canEdit: true,
      title: 'ویرایش پروفایل',
      className: undefined,
    },
    SHOW_PROFILE: {
      name: 'show_profile',
      canEdit: false,
      title: 'نمایش پروفایل',
      className: undefined,
    },
    SCHOLARSHIP_REVIEW: {
      name: 'scholarship_review',
      canEdit: false,
      title: '',
      className: classes.removeHeader,
    },
  }

  React.useEffect(() => {
    if (location?.pathname === '/app/profile/edit') {
      // dispatch(getUserProfileInfo())
      setStatus(statusType.EDIT_PROFILE)
    } else if (location?.pathname?.includes('/app/customers/view/')) {
      dispatch(getUser(userId))
      setStatus(statusType.SHOW_PROFILE)
    } else if (location?.pathname?.includes('scholarships/review/')) {
      setStatus(statusType.SCHOLARSHIP_REVIEW)
    }
  }, [])

  const getProfile = () => {
    switch (status.name) {
      case statusType.SCHOLARSHIP_REVIEW.name: {
        return scholarship?.user
      }
      case statusType.SHOW_PROFILE.name: {
        return users
      }
      case statusType.EDIT_PROFILE.name: {
        return userProfile
      }
      default: return {}
    }
  }

  const userInfo = getProfile()

  return (
    <Page
      className={classes.root}
      title={status.title}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          {width === 'xs' || width === 'sm' ? (
            <>
              <Grid item lg={3} md={4} xs={12}>
                <ProfileImage
                  canEdit={status.canEdit}
                  userinfo={userInfo}
                  fileRef={fileRef}
                  lastPhoto={userProfile?.photo?.url}

                />
              </Grid>
              <Grid item lg={9} md={8} xs={12}>
                <ProfileInfo
                  canEdit={status.canEdit}
                  userinfo={userInfo}
                  fileRef={fileRef}
                  title={status.title}
                  className={status.className}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item lg={9} md={8} xs={12}>
                <ProfileInfo
                  canEdit={status.canEdit}
                  userinfo={userInfo}
                  fileRef={fileRef}
                  title={status.title}
                  className={status.className}
                />
              </Grid>
              <Grid item lg={3} md={4} xs={12}>
                <ProfileImage
                  canEdit={status.canEdit}
                  userinfo={userInfo}
                  fileRef={fileRef}
                  lastPhoto={userProfile?.photo?.url}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Page>
  )
}

ProfileView.propTypes = {
  width: PropTypes.string,
}

export default withWidth()(ProfileView)
